import React, { useEffect, useState } from "react";
import { ValidateResponse, getCurrentPage, setCurrentPage } from "../../helpers/global";
import { fetchProducts } from "../../helpers/articles";
import { List } from "../../../components/List";
import { ListPagination } from "../../../components/List/Pagination";
import { Message } from "../../../components/Message";
import { ContentGenerateExcel } from "../../../components/Content/GenerateExcel";
import { ContentWrapper } from "../../../components/Content/Wrapper";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function AppManagementOverviewsProducts({ current, setFilterFields, filterValues, identifier }) {

    let pageSize = 10; // default values ergens globaal opslaan?
    const tabType = current === 'productslocation' ? 'location' : 'depot';
    const [products, setProducts] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadFilters, setLoadFilters] = useState(true);
    const [pageNr, setPageNr] = useState(getCurrentPage(tabType));
    const [totalCount, setTotalCount] = useState(0);
    const [error, setError] = useState();
    const [filters, setFilters] = useState(JSON.parse(localStorage.getItem("filters" + identifier)));
    const [filterString, setFilterString] = useState("{}");
    const [documentName, setDocumentName] = useState();

    if (JSON.stringify(filterValues) !== filterString) {
        setFilterString(JSON.stringify(filterValues));
        setIsLoaded(false);
        setFilters(filterValues);
        setCurrentPage(1, tabType, setPageNr);
    }

    if (pageNr !== getCurrentPage(tabType)) {
        setPageNr(getCurrentPage(tabType));
    }

    const handlePagination = (page) => {
        setCurrentPage(page, tabType, setPageNr);
    }

    let allColums = [
        { key: "title", type: "title", hideView: "large" },
        { key: "articleName", label: "Artikelnaam", type: "text", hideView: 'small' },
        { key: "serialNumber", label: "Serienr.", type: "text", hideView: 'small' },
        { key: "productStatus", label: "Productstatus", type: "text" },
        { key: "startDate", label: "Startdatum depot", type: "date" },
        { key: "owner", label: "Locatie", type: "text" },
        { key: "departmentRoom", label: "Afdeling/kamernr.", type: "text" },
        { key: "registrationDate", label: "Bouwjaar", type: "date" },
        { key: "productBrand", label: "Merk", type: "text" },
        { key: "productType", label: "Type", type: "text" },
        { key: "quality", label: "Kwaliteit", type: "text" }
    ];

    // Filter relevant columns for depot status in-or out
    let listColumns = [];
    allColums.forEach((row) => {
        if (tabType === 'location'
            && row.key !== 'productStatus'
            && row.key !== 'depotStatus'
            && row.key !== 'startDate') {
            listColumns.push(row);
        }
        else if (tabType === 'depot'
            && row.key !== 'owner'
            && row.key !== 'departmentRoom') {
            listColumns.push(row);
        }
    });

    const defineFilterFields = () => {

        const optionsQuality = [
            { label: "Goed", value: "GOOD" },
            { label: "Matig", value: "AVERAGE" },
            { label: "Slecht", value: "BAD" }
        ]

        // The filters are set here and send to parent onloaded
        let filterFields = {
            articleCategory: { type: 'categories', label: "Artikelcategorie", options: { output: "depot", category: "categoryId", article: "articleId" } },
            location: { type: 'location' },
            clientName: { type: 'text', label: "Naam cliënt" },
            serialNumber: { type: 'text', label: "Serienr." },
            frameNumber: { type: 'text', label: "Framenr." },
            registrationDateFrom: { type: 'text', label: "Bouwjaar van" },
            registrationDateTo: { type: 'text', label: "Bouwjaar tot" },
            quality: { type: 'select', label: "Kwaliteit", options: optionsQuality },
        }

        if (tabType === 'depot') {
            delete filterFields['location'];
        }

        setFilterFields(filterFields);
    }

    useEffect(() => {

        async function fetchData() {

            const callData = {
                filters: {
                    tabType: tabType,
                    limitOffset: pageSize * pageNr - (pageSize - 1),
                    limitRows: pageSize,
                    ...filters
                }
            }

            await fetchProducts(callData).then((res) => {

                const response = ValidateResponse(res.data, 'products');
                if (response.status === 'success') {

                    if (response.totalCount !== undefined) {
                        setTotalCount(response.totalCount);
                    }
                    setProducts(response.products);
                    setDocumentName(response.documentName);
                    setIsLoaded(true);

                    if (loadFilters !== tabType) {
                        defineFilterFields();
                        setLoadFilters(tabType);
                    }
                }
                else {
                    setError(response.message);
                }
            }).catch((error) => {
                const response = ValidateResponse(error);
                setError(response.message);
            });
        }

        fetchData();
    }, [tabType, pageNr, filters, filterString, pageSize]);

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (products === undefined || products === null || Object.keys(products).length === 0) {
        return (<Message type="noData" />);
    }

    const excelbutton = () => {
        return <ContentGenerateExcel
            documentType={'products'+tabType}
            filters={filters}
            display={'button-download'}
            fileName={documentName}
            mimeType={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
            label={'Download excel'}
        />
    }

    return (
        <>
            <ContentWrapper type='page-component' className="floating-button" content={excelbutton()} />
            <List
                columns={listColumns}
                data={products}
                identifier={identifier}
            />

            <div className={'spacer'}></div>

            <ListPagination
                currentPage={pageNr}
                setCurrentPage={handlePagination}
                totalCount={totalCount}
                pageSize={pageSize}
            />
            <div style={{ height: '30px' }}></div>
        </>
    );
}